export const SHARED_INVITE_USER_REQUEST = 'SHARED_INVITE_USER_REQUEST';
export const SHARED_INVITE_USER_SUCCESS = 'SHARED_INVITE_USER_SUCCESS';
export const SHARED_INVITE_USER_FAIL = 'SHARED_INVITE_USER_FAIL';

export const SHARED_INVITE_USER_BY_EMAIL_REQUEST = 'SHARED_INVITE_USER_BY_EMAIL_REQUEST';
export const SHARED_INVITE_USER_BY_EMAIL_SUCCESS = 'SHARED_INVITE_USER_BY_EMAIL_SUCCESS';
export const SHARED_INVITE_USER_BY_EMAIL_FAIL = 'SHARED_INVITE_USER_BY_EMAIL_FAIL';